import { VisionLinkHealthDataProp } from '../../../../types';
import { CatHeading } from '@blocks-react/components/Heading';
import { CatBadge } from '@blocks-react/components/Badge';

export const MediumSeverity = ({ children }: VisionLinkHealthDataProp) => {
  return (
    <div className="d-flex mt-1">
      <CatBadge isDot className="d-flex align-items-center" variant="orange" />
      <CatHeading variant="footnote">{children}</CatHeading>
    </div>
  );
};
